module.exports = __webpack_public_path__ + "static/media/Refresh White.763a3440.svg";